var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13.6,
    viewBox: "0 0 17 13.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-door-closed",
    "data-name": "Icon awesome-door-closed",
    d: "M16.575,11.9H13.6V1.349A1.315,1.315,0,0,0,12.325,0H4.675A1.315,1.315,0,0,0,3.4,1.349V11.9H.425A.425.425,0,0,0,0,12.325v.85a.425.425,0,0,0,.425.425h16.15A.425.425,0,0,0,17,13.175v-.85A.425.425,0,0,0,16.575,11.9ZM11.05,7.65a.85.85,0,1,1,.85-.85A.85.85,0,0,1,11.05,7.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDoor);
export default __webpack_public_path__ + "static/media/close_door.4a0dd0dc70267c09684eee5f50583e0d.svg";
export { ForwardRef as ReactComponent };